import ChevronDown from "@assets/images/chevron-down-2.svg";
import ChevronUp from "@assets/images/chevron-up-2.svg";
import { Box, Collapse, Grid } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import SVG from "react-inlinesvg";

interface CollapseFilterProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  label: string | React.ReactNode;
}

const useStyles = makeStyles(
  theme => ({
    wrapper: {
      borderRadius: 6,
      background: "white",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      overflow: "hidden",
      marginTop: "1.6rem",
      marginBottom: "1.6rem",
      width: "100%"
    },
    header: {
      cursor: "pointer",
      padding: "0.8rem 2.6rem",
      background: theme.palette.gardient.medium,
      colors: "white",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "60px",
      "& .MuiTypography-root": {
        color: "white"
      },
      "& .MuiTypography-h6": {
        lineHeight: "2.4rem",
        fontSize: "18px"
      }
    }
  }),
  { name: "CollapseFilter" }
);

const CollapseFilter: React.FC<CollapseFilterProps> = props => {
  const { children, isOpen, setIsOpen, label } = props;
  const classes = useStyles();
  return (
    <>
      <Box className={classes.wrapper}>
        <Grid
          className={classes.header}
          container
          onClick={() => setIsOpen(!isOpen)}
        >
          <MyTypography variant="h6">{label}</MyTypography>
          {isOpen ? <SVG src={ChevronUp} /> : <SVG src={ChevronDown} />}
        </Grid>
        <Collapse in={isOpen}>{children}</Collapse>
      </Box>
    </>
  );
};

export default CollapseFilter;
